import BancoService from "@/api/services/finanzas/nomencladores/BancoService"
import Vue from "vue"

const state = () => ({
    bancos: [],
    pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 10,
        sortBy: "nombre",
        rowsPerPageItems: [5, 10, 20, 30, 40, 50]
    }
})

const getters = {
    BANCOS: state => {
        return state.bancos
    },
    BANCOS_PAG: state => {
        return state.pagination
    }
}

const mutations = {
    SET_BANCOS: (state, payload) => {
        state.bancos = payload
    },

    SET_BANCOS_PAG: (state, payload) => {
        state.pagination = payload
    },

    ADD_BANCO: (state, payload) => {
        state.bancos.push(payload)
    },

    UPDATE_BANCO: (state, payload) => {
        state.bancos = state.bancos.map(el => (el.id === payload.id ? payload : el))
    },

    DELETE_BANCO: (state, payload) => {
        state.bancos = state.bancos.filter(el => el.id !== payload.id)
    }
}

const actions = {
    LOAD_BANCOS: async ({ commit, state }, { filter, bancoEstado }) => {
        try {
            let pagination = {
                page: state.pagination.page,
                rowsPerPage: state.pagination.rowsPerPage,
                sortBy: state.pagination.descending ? "-" + state.pagination.sortBy : state.pagination.sortBy
            }
            let { data, status, headers } = await BancoService.get({ filter, bancoEstado, ...pagination })
            if (status === 200) {
                commit("SET_BANCOS", data)
                return parseInt(headers["x-pagination-total-count"])
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar los bancos, inténtelo nuevamente"
            })
        }
    },

    LOAD_ALL_BANCOS: async ({ commit }) => {
        try {
            let { data, status } = await BancoService.getAll()
            if (status === 200) {
                commit("SET_BANCOS", data)
                return data
            }
        } catch (error) {
            if (error.response) {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    LOAD_ALL_RECORDS_BANCOS: async ({ commit }) => {
        try {
            let { data, status } = await BancoService.getAllRecords()
            if (status === 200) {
                commit("SET_BANCOS", data)
                return null
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido cargar los bancos, inténtelo nuevamente"
            })
        }
    },

    LOAD_HISTORY_BANCO: async ({ commit }, payload) => {
        try {
            let { data, status } = await BancoService.getHistory(payload)
            if (status === 200) {
                commit("UPDATE_BANCO", data)
            }
            return null
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido cargar el historial del banco, inténtelo nuevamente"
            })
        }
    },

    ADD_BANCO: async ({ commit }, payload) => {
        try {
            let { data, status } = await BancoService.post(payload)
            if (status === 201) {
                commit("ADD_BANCO", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Agregando",
                    text: "El banco ha sido agregado satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido agregar el banco, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    UPDATE_BANCO: async ({ commit }, payload) => {
        try {
            let { data, status } = await BancoService.put(payload)
            if (status === 200) {
                commit("UPDATE_BANCO", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Modificando",
                    text: "El banco ha sido modificado satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido modificar el banco, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    DELETE_BANCO: async ({ commit }, payload) => {
        try {
            let { status, data } = await BancoService.delete(payload)
            if (status === 204) {
                commit("DELETE_BANCO", payload)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Eliminando",
                    text: "El banco ha sido eliminado satisfactoriamente"
                })
            }
            if (status === 200) {
                commit("UPDATE_BANCO", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Deshabilitando",
                    text: "El banco ha sido deshabilitado  satisfactoriamente"
                })
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido eliminar/deshabilitar el historial del banco, inténtelo nuevamente"
            })
        }
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}
